module.exports = __webpack_public_path__ + "img/FR18950.f3582c5f.png";